import { z } from 'zod/v4';

export const AbsoluteTimeRangeDTO = z.object({
  type: z.literal('absolute'),
  value: z.tuple([z.any(), z.any()]).nullish(),
});
export const RelativeTimeRangeDTO = z.object({
  type: z.literal('relative'),
  value: z.number().nullish(),
});
export const TimeRangeDTO = z.union([
  AbsoluteTimeRangeDTO,
  RelativeTimeRangeDTO,
]);
export type TimeRange = z.infer<typeof TimeRangeDTO>;